import { API_BASE_URL } from "./config/apiConfig";

export async function http(method, url, data) {
  const accessToken = localStorage.getItem("accessToken");
  const refreshToken = localStorage.getItem("refreshToken");

  const cleanBase = API_BASE_URL.replace(/\/$/, "");
  const cleanUrl = url.startsWith("/") ? url : "/" + url;

  const fullUrl = cleanBase + cleanUrl;

  const options = {
    method,
    headers: {}
  };

  // Nếu có body
  if (data !== undefined && data !== null) {
    if (data instanceof FormData) {
      options.body = data;
      // KHÔNG set Content-Type, fetch sẽ set
    } else {
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(data);
    }
  }

  // Gắn token
  if (accessToken) {
    options.headers["Authorization"] = `Bearer ${accessToken}`;
  }

  let res;

  // Hàm thực thi request
  async function doFetch() {
    return await fetch(fullUrl, options);
  }

  try {
    res = await doFetch();
  } catch (err) {
    throw new Error("Network error: " + err.message);
  }

  // Nếu 401 → thử refresh token
  if (res.status === 401 && refreshToken) {
    try {
      const refreshRes = await fetch(cleanBase + "/auth/refresh", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refreshToken })
      });

      if (refreshRes.ok) {
        const refreshData = await refreshRes.data.json();
        localStorage.setItem("accessToken", refreshData.accessToken);

        // Update Authorization header
        options.headers["Authorization"] = `Bearer ${refreshData.accessToken}`;

        // retry request gốc
        res = await doFetch();
      } else {
        localStorage.clear();
        throw new Error("Session expired");
        window.location.href = "/login";
      }
    } catch (e) {
      localStorage.clear();
      throw new Error("Session expired");
    }
  }

  // Nếu vẫn lỗi
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`HTTP ${res.status}: ${text}`);
  }

  // JSON hay không?
  const contentType = res.headers.get("content-type") || "";
  if (contentType.includes("json")) {
    return await res.json();
  }

  return null;
}

export const api = {
  get: (url) => http("GET", url),
  post: (url, data) => http("POST", url, data),
  put: (url, data) => http("PUT", url, data),
  delete: (url) => http("DELETE", url),
};
